<div *ngIf="form && form.get(controlName) && form.get(controlName).errors">
    <ng-container *ngIf="form.get(controlName).invalid && form.get(controlName).touched">
        <mat-error *ngFor="let errorKey of ObjectKey(errors.value)">
            {{ errors.value[errorKey].message }}
        </mat-error>
    </ng-container>
</div>
